import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeComponent from "../HomeComponent/HomeComponent";

const TableComponent = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const url = "https://staging-onepharma.etr-analytics.com/api/v1/run/v1/data";
  const token = "eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTUxMiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjMiLCJGaXJzdE5hbWUiOiJFeGVjdXRpdmUgIiwiTGFzdE5hbWUiOiJTZXJ2aWNlIEFjY291bnQiLCJQZXJtaXNzaW9uIjoiQ2FuQWNjZXNzUmVzb3VyY2UiLCJJZGVudGlmaWVycyI6ImV5SkVZWFJoSWpwYlhTd2lVM1ZqWTJWemN5STZkSEoxWlN3aVRXVnpjMkZuWlNJNmJuVnNiSDA9IiwiZXhwIjoxNzQwOTkyMjgzLCJpc3MiOiJodHRwczovL29uZXBoYXJtYS5ldHItYW5hbHl0aWNzLmNvbS9hcGkiLCJhdWQiOiJodHRwczovL29uZXBoYXJtYS5ldHItYW5hbHl0aWNzLmNvbS9hcGkifQ.qIPzA3RUIgGg-POiK_TykoAZY0i6B3H6KttSdc9RaJbsoY8igSNQMYl8lO_Og1hyUFxnYHnDGOlWTtIhHQZaog"


  const parameters = {
    "id": "N68",
    "params": [
      {
        "key": "FromMonth",
        "value": "1"
      },
      {
        "key": "FromYear",
        "value": "2024"
      },
      {
        "key": "ToMonth",
        "value": "1"
      },
      {
        "key": "ToYear",
        "value": "2024"
      },
      {
        "key": "ConfigTypeCode",
        "value": "Y2024"
      }
    ]
  }

  const storageKey = JSON.stringify(parameters);

  const columns = [
    {
      name: 'District Manager Name',
      selector: row => row.DistrictManagerName,
      sortable: true,
      grow: 3
    },
    {
      name: 'District Name',
      selector: row => row.DistrictName,
      sortable: true,
      grow: 1
    },
    {
      name: 'Sales',
      selector: row => row.ActualSales,
      sortable: true,
      grow: 5,
      cell: (row, index) => (
        <input
            type="text"
            value={row.ActualSales}
            onChange={(e) => handleEdit(index, "ActualSales", e.target.value)}
            style={{ width: "100px" }}
        />
    )
    }
  ];

  useEffect(() => {
    window.addEventListener("online", () => setIsOnline(true));
    window.addEventListener("offline", () => setIsOnline(false));
    return () => {
      window.removeEventListener("online", () => setIsOnline(true));
      window.removeEventListener("offline", () => setIsOnline(false));
    };
  }, []);

  const fetchData = async () => {
    if (!isOnline) {
      console.log("Offline mode: Using local storage data.");
      const localData = localStorage.getItem(storageKey);
      if (localData) setData(JSON.parse(localData));
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(parameters)
      });

      if (!response.ok) {
        console.log('Faled Fetch!');
      }

      const data = await response.json();
      const dataPasrse = JSON.parse(data.result.data)

      localStorage.setItem(storageKey, data.result.data);
      setData(dataPasrse);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = (rowIndex, field, value) => {
    const updatedData = data.map((row, index) =>
      index === rowIndex ? { ...row, [field]: value } : row
    );
    setData(updatedData);
    localStorage.setItem(storageKey, JSON.stringify(updatedData));
  };

  return (
    <div className="container mt-4">
      <h2>Table</h2>
      {loading ? (<div>loading..</div>) :
        (
          <div>
            <DataTable
              className="listings-table"
              columns={columns}
              data={data}
              highlightOnHover={true}
              pointerOnHover={true}
              striped={true}
              fixedHeader={true}
              responsive={true}
              expandOnRowClicked={false}
              expandableRows={false}
              expandableRowsHideExpander={true}
              pagination={false}
            />
          </div>
        )
      }

      <div>
        <HomeComponent />
      </div>
    </div>
  );
};

export default TableComponent;
